export default __webpack_public_path__ + "locales/ko-KR/Payments.json?hash=e3bcd24740b785c80e10bc8961e924fe";